import { TOP_SHOP_RETAILER_EXPERIENCE_ENABLED_BY_REGION_220322 } from "@faire/web-api--source/indigofair/settings/TOP_SHOP_RETAILER_EXPERIENCE_ENABLED_BY_REGION_220322";

import { getSettingValueWithoutAssignment } from "@faire/retailer-visitor-shared/settings/__internal__/getSetting";

export const getSettingTopShopRetailerExperienceEnabledByRegion = (): boolean =>
  getSettingValueWithoutAssignment(
    TOP_SHOP_RETAILER_EXPERIENCE_ENABLED_BY_REGION_220322,
    false
  );
